export default {
  ssb: {
    name: 'Statistisk sentralbyrå',
    url: 'https://ssb.no/',
  },
  oslo: {
    name: 'Oslo kommune',
    url: 'https://statistikkbanken.oslo.kommune.no/',
  },
  boligmappa: {
    name: 'Boligmappa AS',
    url: 'https://www.hjemla.no',
  },
};
